import $ from 'jquery'

window.$ = $
